import { render, staticRenderFns } from "./userQuery.vue?vue&type=template&id=0f2c70c2&scoped=true"
import script from "./userQuery.vue?vue&type=script&lang=js"
export * from "./userQuery.vue?vue&type=script&lang=js"
import style0 from "./userQuery.vue?vue&type=style&index=0&id=0f2c70c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2c70c2",
  null
  
)

export default component.exports